import {call, put} from 'redux-saga/effects';
import axios from 'axios';

import * as homeActionType from '../actionType/home.actionType';
import appConfig from '../../../static/data/env/envSettings';
import {getBaseUrl} from '../../utilities/filter.utility';

function callHomeData(req) {
    return axios.get('http://localhost:3000/homeData');
}

// function getPublicLibraryData() {
//     return axios.get('static/data/PublicLibraries.json');
// }

export function* homeSaga(req) {
    try {
        // debugger;
        const homeDataResp = yield call(callHomeData, req);
        yield put({
            type: homeActionType.SET_HOME_DATA,
            payload: homeDataResp.data[0]
        });
    } catch (e) {
        yield put({
            type: homeActionType.SET_HOME_CALL_ERROR,
            payload: e.message
        });
    }
}

export function* submitContactSaga(reqObj) {
    try {
        const res = yield axios.post(
            `${getBaseUrl()}/${appConfig.serviceEndPoints.submitContact}`,
            {...reqObj.payload}
        );
        if (res && res.data) {
            const result = res.data;
            yield put({
                type: homeActionType.UPDATE_CONTACT_STS,
                payload: {
                    contactStatus: result
                }
            });
        } else {
            yield put({
                type: homeActionType.UPDATE_CONTACT_STS,
                payload: {
                    contactStatus: 'Technical difficulty. Please try later.'
                }
            });
        }
        yield put({
            type: homeActionType.UPDATE_CONTACT_STS,
            payload: {
                contactStatus: 'success'
            }
        });
    } catch (error) {
        yield put({
            type: homeActionType.UPDATE_CONTACT_STS,
            payload: {
                contactStatus: 'Technical difficulty. Please try later.'
            }
        });
    }
}

export function* getPublicLibrarySaga(reqObj) {
    try {
        const res = yield axios.post(
        `${getBaseUrl()}/${appConfig.serviceEndPoints.getPublicLibraries}`);
        // const res = yield call(getPublicLibraryData, reqObj);
        if (res && res.data) {
            yield put({
                type: homeActionType.FETCH_PUBLIC_LIBRARIES_SUCCESS,
                payload: res.data
            });
        } else {
            yield put({
                type: homeActionType.FETCH_PUBLIC_LIBRARIES_ERROR,
                payload: 'Technical difficulty. Please try later.'
            });
        }
    } catch (error) {
        yield put({
            type: homeActionType.FETCH_PUBLIC_LIBRARIES_ERROR,
            payload: {
                contactStatus: 'Technical difficulty. Please try later.'
            }
        });
    }
}

export function* getDSPUrlSaga(reqObj) {
    try {
        const res = yield axios.post(
            `${getBaseUrl()}/${appConfig.serviceEndPoints.getDSPUrl}`);
        if (res && res.data) {
            yield put({
                type: homeActionType.FETCH_DSP_URL_SUCCESS,
                payload: res.data
            });
        } else {
            yield put({
                type: homeActionType.FETCH_DSP_URL_ERROR,
                payload: 'Technical difficulty. Please try later.'
            });
        }
    } catch (error) {
        yield put({
            type: homeActionType.FETCH_DSP_URL_ERROR,
            payload: {
                contactStatus: 'Technical difficulty. Please try later.'
            }
        });
    }
}
